// extracted by mini-css-extract-plugin
export default {"root":"styles_root__8vwU2","spacer":"styles_spacer__P9NNY","submit":"styles_submit__9Wwng","error":"styles_error__YbQ9I"};